<script>
import PfCard from './PfCard.vue'
import InfoP from './InfoP.vue'
// import FadeIn from './FadeIn.vue'

export default {
  components: {
    InfoP,
    PfCard,
    //    FadeIn,
  },
  methods: {
    onScroll (e) {
      if (typeof window === 'undefined') return
      const top = window.pageYOffset || e.target.scrollTop || 0
      this.fab = top > 500
    }
  },
  data: () => ({
    fab: false,
    repairLists: [
      { 
        title:'全国どこからでも修理承ります',
        sub:'お気軽にご相談ください', 
        body:'自分の使っていたピアノをもう一度<span class="u">完璧に直す</span><br>買い替えることは簡単な話だけれどもどうしても手放せない気持ちと愛着と歴史が詰まったピアノは何物にも代えられないものだ<br>ピアピット修理集団ピアノマニアたちがじっくり<span class="u">丹精込めて</span>手を加えていく<br>人のピアノだけれどもだんだん愛着がのりうつる、<br>最後は自分のピアノのような気持ちになる、そういう気持ちが伝わると嬉しいしやっててよかったなあ～～と思える、<br>毎日修理しているがこれが全然飽きないし、深いところまで感覚が持って行かれてしまう・・・・・修理ポイズンとでもいおうか、<br>あまりお金にはならない仕事だがやめられない<br>何十年たってもピアノに教えられることばかりで、ピアノの深さを改めて感じる今日この頃毎日が勉強です',
        image: require('@/assets/l20220316a.jpg'),
      },
      { 
        title:'カスタム、ネーム入れ',
        sub:'塗装込み、18,000円(税込み)', 
        body:'ピアノの好きな場所に好きな文字をお入れします<br>書体、色などカスタマイズできます',
        image: require('@/assets/customName.jpg'),
      },
      { 
        title:'弦の張り替え',
        sub:'レスロ、ヤマハ、カワイなど弦のメーカーを選択できます', 
        body:'使用頻度、使用年数によっては、弦のクリーニングで十分な場合もあります',
        image: require('@/assets/s20220216.jpg'),
      },
      { 
        title:'部品交換',
        sub:'痛んでいる部品が新品に交換します', 
        body:'ピアノのタッチや音色がよみがえります',
        image: require('@/assets/s20220206.jpg'),
      },
      { 
        title:'鍵盤修理',
        sub:'新品同様に白さがよみがえり、感触も変わります', 
        body:'白鍵表皮貼り替え<br>ブッシングクロス貼り替え',
        image: require('@/assets/s20211119.jpg'),
      },
    ],
    cleaningLists: [
      { 
        title:'クリーニング',
        sub:'お手持ちのピアノを悪いところを直してもう一度再生します。既存の部品が生きていればそれに手を加えることによりまた使えるようになります', 
        body:'<div class="m">クリーニングの流れ</div>キズ～汚れまで先にチェックしておきます、ある程度の汚れ細かい傷は クリーニング磨き作業で落とすことができます。<br><br>ピアノパネルを取り外して<span class="u">鍵盤等のチェックとけん盤下の掃除</span> 鍵盤下等虫食いネズミにかじられ食われしていること多々あります 一番多いのは虫食いですね、鍵盤のブッシングまで食われる事多し<br><br><span class="u">ピアノを寝かして</span>底板の取り外し分解、 ピアノは寝かすと見えなかったところまであらわに見えるより細部深部まで目が行き届く、底板にたまる埃カビは隅々まで深く浸透している 表面だけふき取ってもカビ虫埃は取れない、よって取り外して 掃除研磨し同時にピアノ底部分の状態までチェック修理できる<br><br>ここはお客様の家では寝かすことはできないのでこういう時にこそきれいにしたい。同時の底板ビスは100％さび付いているために 交換は確実にしておきたい、<span class="u">底板ビスが交換</span>されているかは手鏡があればピアノペダルから差し込めばビス頭がぴかぴかであれば交換されています。<br><br>底板を取り外すと同時にペダル窓も取外し磨き ペダル窓につく<span class="u">クッションクロスフェルトも新品</span>に交換されます。',
        image: require('@/assets/c20211020.jpg'),
      },
      { 
        title:'鍵盤バフがけ',
        sub:'鍵盤の爪跡がなくなります', 
        body:'',
        image: require('@/assets/l20220316g.jpg'),
      },
      { 
        title:'ハンマー整形',
        sub:'ピアノの音がやわらかくなります', 
        body:'',
        image: require('@/assets/cleaning2.jpg'),
      },
      { 
        title:'弦磨き',
        sub:'', 
        body:'',
        image: require('@/assets/c20210821.jpg'),
      },
      { 
        title:'磨き',
        sub:'', 
        body:'',
        image: require('@/assets/cleaning4.jpg'),
      },
    ],
    paintLists: [
      { 
        title:'世界に1台',
        sub:'カスタム模様', 
        body:'',
        image: require('@/assets/toso2.jpg'),
      },
      { 
        title:'部分的に塗装',
        sub:'開いた部分のみにも塗装できます', 
        body:'40,000円〜',
        image: require('@/assets/p20220213.jpg'),
      },
      { 
        title:'木目調に',
        sub:'黒いピアノを木目調にしました', 
        body:'280,000円〜',
        image: require('@/assets/p20200315.jpg'),
      },
      { 
        title:'白いピアノに変身',
        sub:'', 
        body:'280,000円〜',
        image: require('@/assets/p20210905.jpg'),
      },
    ],
    tuneLists: [
      { 
        title:'ピアノ調律',
        sub:'13,000円(税抜)〜', 
        body:'アップライトピアノ 13,000円(税抜)<br>グランドピアノ17,000円(税抜)<br><br>*遠方出張費かかります<br>*修理がある場合は、別途修理費がかかります<br><br>ピアノ調律師も<span class="u">ピアノ調律技能士</span>ということになる、試験を受け基準に満たしたものが技能士の資格を与えあたえられる。いままで調律師の定義すらなかったこの世界、この制度が導入されることにより<br>ユーザーも安心して頼める制度だ、すでに５年以上たつ制度なのでこの世界でご飯を食べさせてもらっている調律師は必ず受け２級もしくは１級を取る、３級は調律学校出たての人が受けるのが一般的<br>それでは全員受かるのか？？ここが合格率がめちゃくちゃ低い低すぎる～<br>全ての級において実に低い合格率、これは文科省もびっくりという<br>３級受からないという事は正直音階ができてもいないということに等しい、100点をとる制度ではなく<br>たった70％の精度で良いところなのでそれ以下ということはお話にならないところがあらわになる<br>今までこういう制度もなくユーザーは10,000円以上のお金を払ってきた・・・・・精度がひどくても良くてもだ<br>そういうところに調律師協会の呼びかけにより一線を引くことができた。<br>ユーザーも技能士に頼むという選択は間違っていない<br>この制度は大きくこの業界を変えてきている<br>我々調律師にとっても技能を判断してくれたという意味でも国家資格のもと調律をさせていただいている<br>責任感は大きい。必ず頼むときは<span class="u">国家資格取得者</span>に頼まない手はないのだ<br>調律は、この制度を知っておけば名刺をもらっただけで判断できる。',
        image: require('@/assets/t20220216.jpg'),
      },
    ],
    saleLists: [
      { 
        title:'バーズアイメイプル・カスタマイズ',
        sub:'1,474,000円(税込み)', 
        body:'一枚象牙、黒檀、猫足<br><iframe width="100%" height="315" src="https://www.youtube.com/embed/tjzVzNWSR8k" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>',
        image: require('@/assets/s20220619a.jpg'),
        image2: require('@/assets/s20220619b.jpg'),
      },
      { 
        title:'フリッツクーラー',
        sub:'473,000円(税込み)', 
        body:'弦・ピン・ハンマー交換済み',
        image: require('@/assets/s20220619x.jpg'),
        image2: require('@/assets/s20220619y.jpg'),
      },
      { 
        title:'遠州ピアノ',
        sub:'新品803,000円(税込み)', 
        body:'メイドイン <b>“ジャパン”</b><br>ピアピットで試奏できます',
        image: require('@/assets/s20220609a.jpg'),
        image2: require('@/assets/s20220609b.jpg'),
        image3: require('@/assets/s20220609c.jpg'),
      },
      { 
        title:'アトラス A55M',
        sub:'売約済み', 
        body:'ワイン色132cm<br>弦、新品、レスロ<br>猫足',
        image: require('@/assets/s20220515a.jpg'),
        image2: require('@/assets/s20220515b.jpg'),
        image3: require('@/assets/s20220515c.jpg'),
      },
      { 
        title:'キンボール',
        sub:'整備済み360,000円(税込み)', 
        body:'バス新品弦張り替え済み',
        image: require('@/assets/s20220315.jpg'),
      },
      { 
        title:'カワイBL61ベースピアピットカスタム',
        sub:'売約済み', 
        body:'世界に一台!!<br>高さ 132cm<br>制作時動画<iframe width="100%" height="315" src="https://www.youtube.com/embed/zKuL3g1v6OI" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>',
        image: require('@/assets/p20220425.jpg'),
      },
    ],
    schoolLists: [
      { 
        title:'ピアピットピアノ教室、ギター教室',
        sub:'4歳〜大人まで', 
        body:'入会金2,000円<br>月謝6,000円(税別)より<br>年1回の発表会あり<br>ピアノ:スタンウエイD275',
        image: require('@/assets/school.jpg'),
      },
    ],
    silentLists: [
      { 
        title:'ピアノ消音ユニット',
        sub:'夜もピアノを弾きたい人のために', 
        body:'マジックスターサイレンサーシステム<br>アップライト 140,000円(工賃込・税別)<br>グランド 285,000円(工賃込・税別)<br><br>コルグ製、ピアメイト製もお取り扱いしています',
        image: require('@/assets/s20200921.jpg'),
      },
    ],
    granLists: [
      { 
        title:'グランフィール取り付け',
        sub:'グランドピアノのあの響きを。タッチをアップライトピアノに', 
        body:'発明者 <a href="https://fujiipianoservice.jp/granfeel/">藤井幸光(藤井ピアノサービス)</a><br><br>グランフィールを作るきっかけとなったのは一生懸命にアップライトで練習している子供たちの姿。そして声でした<br>ピアノの仕事にたずさわって30年「せっかく練習してきたのに、発表会やコンクールで弾く<span class="u">グランドピアノでは思うように弾けない</span>。」<br>という多くの声を聞きました。緊張も一因としてあるでしょう、しかしグランドピアノとアップライトピアノでは<span class="u">性能に大きな差</span>があり、いくらアップライトピアノで練習しても本番でグランドピアノとなると、タッチや音質にどうしても影響が出てしまいます。<br>そしてもう一つ決定的な違いがあります。<span class="u">グランドピアノとアップライトピアノでは前腕の筋肉の使い方が全く異なる</span>のです<br>グランドピアノで演奏するときは前腕の手の甲側にある伸筋はほとんど使わないのに対して<span class="u">アップライトピアノで演奏するときは</span>、前腕の手のひら側の屈筋と手の甲側にある伸筋を鍵盤を押さえるたびに<span class="u">交互に使う必要</span>があります。<br>指を上げたり下げたりする運動は前筋の伸筋と屈筋を使います上げる動きと下げる動きが同時にできないように伸筋と屈筋も同時には運動できません。<br>鍵盤を押えるために指を下げると手のひら側の屈筋が収縮して手の甲側の伸筋は緩んでいる状態になります、逆に鍵盤から指を離すために上げると手の甲側の伸筋が収縮して手のひら側の屈筋が、ゆるむことになります。<br><span class="u">グランドピアノの構造は</span>弾いた鍵盤の<span class="u">力を抜くだけで鍵盤が指を押し上げてくれるレピティション機構</span>を備えているので演奏者にとってはとても有り難く有利です<br>しかし<span class="u">従来のアップライトピアノの構造では自分の力で指を持ち上げなければ</span>次の打弦はできず、肩や使わなくてもいい別の筋肉に力が張ってしまい結果的にグランドピアノを弾くより難しい動きが要求されてしまいます。<br>今回私が発明した<span class="u">グランフィールはグランドピアノの機能をアップライトに持たせる</span>（レピティション機構）ことによりコントロール性が向上します<br><br><div class="m">どんなアップライトピアノにも取り付け可能グランフィールの特徴</div><span class="u">ピアニシモで連打ができ</span>トリルなどの素早い連打もスムーズで単音レガート奏法が可能になりより表現力がアップし、<span class="u">打弦性能はグランドに匹敵</span>します<br>押さえた<span class="u">鍵盤を３分の１まで戻すと次の打弦</span>が可能です<br>・・・・・・・今までのアップライトピアノではできなかったダクダク弾くJAZZっぽい演奏も可能です<br><span class="u">鍵盤戻りも素早い</span>ので吸い付いてくる感触は素敵です<br>グランドピアノにあるドロップスクリューの代わりとして<span class="u">ショット＆ドロップスプリング</span><br>そして<span class="u">レピティションスプリング</span>、もう一つ大きな<span class="u">バットスキン形状の改造</span>。<br>正確な位置決めとグランドピアノに精通した知識の取り付ける側に要求されます<br>ハード面は上記に書き込まれている部品を取り付けるということだが、ただ取り付けてＯＫというわけにはいかない<br>60％は調整いかんの世界、<span class="u">絶妙なセッティングは最高のレスポンスに変わる</span><br>そこは取り付けた技術者冥利に尽きるセッティングといえよう<br><span class="u">どんなアップライトピアノにも取り付け可能</span>なので何でもご相談ください<br><span class="u">ベースピアノを直す</span>～～<span class="u">グランフィール取り付け</span>～～<span class="u">絶品なるセッティング調整</span>～～<span class="u">調律</span><br>という流れで完成します<br><br>取り付け金額は <b>210,000円(税別)</b> 最高のピアノに仕上げます<br>バットスキン交換のある場合は、+20,000円になります',
        image: require('@/assets/g20200704.jpg'),
      },
    ],
    aboutLists: [
      { 
        title:'ピアピットについて',
        sub:'超ミステリーな会社ピアピット', 
        body:'<div class="m">ピアピット</div>ナベサンが始めた工房だ<br><span class="u">30年前</span>になるがパソコンもなく何もないところから始まる、調律に行っていたお客様だけの修理工房だった<br><span class="u">当時仕事はなく</span>、好きなサーフィン　ギターどんだけでも練習できたぐらい時間と暇だけはあったらしい<br>しばらくしてからこれからはコンピューターの時代、ドメインとかいうやつをとらないといけないとか言われ <span class="u">ピアピットドットコム</span>、をパソコンが普及する前から取った。<br>・・・・・・・・20万ぐらいかかったような気がする ドメインをとったはいいが、肝心のパソコンがない！！ことを数年たって思い出した。 ・・・・意味わからん<br>と言うことでパソコンを買いに行ったがさてなにをしたらいいのかわからず、最初に覚えたのは 絵を描くことだった、毎日ひたすらパソコンで絵を描いた、しばらくしてなんとやっと<span class="u">メールアドレス</span>を作った<br>それが今のメールアドレスだ、何とも古いアドレスらしい。初期型アドレスと言われることしばしば。最近いくつものメールアドレス作れるんだよと聞いたのは、がしかし今でも１個だけの何変わらないアドレスを使い続けている。<br><span class="u">HPはここ数年初めて</span>作った、その間ピアノの修理ギターイジリ　オーディオ直し<br>好きなことばかりやっていた初期ナベサンとフクチャン。 他から見ればただのぷーたろーのおじさんが遊んでいるとしか見えなかったかもしれない。<br>景気が悪いだの、いいだのと言う言葉ははなはな頭にはなく、<span class="u">仕事がないときはサーフィンに夢中</span>になり<br>毎日カップラーメンばかり食っていた、がこの二人自由を手に入れたかのように毎日にやにやしていたらしい 当時から確かに追求性は恐ろしく執念深い所もありサーフィンのボード形状によって厚さによってウンたらと言ってたし<br>…あんたはサーファーのリペアーか?と言われるほど研究していた、フクチャンはギターの塗装がウンたらと超絶的な技で塗装技術を自ら考案していたし実践していた、<br>たぶんだけど当時の<span class="u">収入は月に5万円～8万円</span>だったと言い放つ<br>よく食えてたものだと今でも自ら不思議がるナベサン<br>私はのちの十数年後にはいったのだが。当時<span class="u">行き当たりばったりの会社</span>だったそのうち治るのかと思いきや<br>今でもなんと行き当たりばったりの会社を貫き動かしているのには驚くばかりで<br>人柄だけのかりそめなバランスを保ちながら30年も続いている会社に驚く始末。<br>売上は上がるが実入りがさっぱりで30年、ほんと<span class="u">笑える会社と言うか笑うしかない会社</span>なのだ それでも好きな仕事をし続ける皆の衆これは無敵なのだ<br><span class="u">収入がなくても手はうごく</span>せっせと働く、これ無敵・・・・・他企業がまねできない会社だ<br>不思議に社員が増える不思議と食べていっている、<span class="u">これぞ現代のミステリー</span>・・・・と言うとかっこいいが<br>しょうがないじゃん・・<span class="u">これしかないんだから精神</span>でも誰も文句は言わないやめもしないところがミステリー',
        image: require('@/assets/l20220316h.jpg'),
      },
    ],
  }),
}
</script>

<template>
  <v-container class="paper" fluid>
    <transition name="fade">
      <v-btn 
        v-scroll="onScroll"
        v-show="fab"
        fixed 
        fab 
        bottom 
        right 
        color="#004dff88" 
        style="bottom: 50px"
        @click="$vuetify.goTo(0)">
        <v-icon color="white">mdi-chevron-up</v-icon>
      </v-btn>
    </transition>
    <!-- hero -->
    <v-row>
      <v-col cols="12" class="pa-0">
        <v-parallax src="@/assets/hero1.jpg">
          <v-row align="center">
            <v-col class="text-center" cols="12">
              <p class="font7 fsize bg">
                あなたのピアノを<br>
                <span class="f75">もう一度歌わせてみませんか♫</span>
              </p>
            </v-col>
          </v-row>
        </v-parallax>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-card height="50" class="d-flex align-center" color="transparent" elevation="0">
          <a href="https://docs.google.com/forms/d/e/1FAIpQLScxsLtLg0BXdz3f1yywU9WNG6kpfOy2w_LEHSda2MW1zG_ZCQ/viewform">
            <v-btn color="primary" elevation="3">
              お問合せフォーム
            </v-btn>
          </a>
          <v-spacer></v-spacer>
          <a href="https://twitter.com/kWhcwKgGy1nItNA?ref_src=twsrc%5Etfw">
            <img src="@/assets/Twitter.png" class="mx-2" width="30px">
          </a>
          <a href="https://www.instagram.com/piano_piapit/">
            <img src="@/assets/Instagram.png" class="mx-2" width="30px">
          </a>
          <a href="https://www.youtube.com/channel/UCEnp7huIAGMgo1InM038a_A">
            <img src="@/assets/youTube.png" class="mx-2" width="30px">
          </a>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col align="center">
        <a href="https://piapit.jimdofree.com" style="text-decoration:none">
          <v-btn color="red accent-3" elevation="3" rounded dark>
           本日の作業とピアノ販売 
          </v-btn>
        </a>
				<p>毎日、更新中！！</p>
      </v-col>
    </v-row>
    <v-row>
      <!-- <v-col align="center"> -->
      <!--   <a href="http://www.piapit.com/index2.html" style="text-decoration:none"> -->
      <!--     <v-btn color="green accent-3" elevation="3" rounded dark> -->
      <!--       より詳しいページへ移動 -->
      <!--     </v-btn> -->
      <!--   </a> -->
      <!-- </v-col> -->
    </v-row>
    <v-row>
      <v-col>
        <p>
          <a href="#" @click="$vuetify.goTo('#repair')">ピアノ修理 | </a>
          <a href="#" @click="$vuetify.goTo('#cleaning')">ピアノクリーニング | </a>
					<!--          <a href="#" @click="$vuetify.goTo('#sale')">ピアノ販売 | </a> -->
          <a href="#" @click="$vuetify.goTo('#paint')">ピアノ塗装 | </a>
          <a href="#" @click="$vuetify.goTo('#tune')">ピアノ調律 | </a>
          <a href="#" @click="$vuetify.goTo('#school')">ピアノ教室 | </a>
          <a href="#" @click="$vuetify.goTo('#silent')">消音ユニット取り付け | </a>
          <a href="#" @click="$vuetify.goTo('#gran')">グランフィール取り付け | </a>
          <a href="#" @click="$vuetify.goTo('#about')">ピアピットについて</a>
        </p>
        <p>全国どこからでもピアノ修理承ります。<br>お気軽にお電話ください！(<b>0120-311-054</b>)<br>「お見積り担当:渡辺 直通 <b>090-3144-6847</b>」<br>見学、ひやかし大歓迎！</p>
          </v-col>
        </v-row>
        <!-- 告知 -->
        <v-row dense>
          <v-col>
            <a href="https://youtu.be/6Xk0fQ7HBOU1" class="text-decoration-none">
              <v-card class="mx-auto" max-width="300">
                <v-img src="@/assets/t20230219.jpg" height="160px">
                </v-img>
                  <v-card-text class="black--text">僕らの凸げき日記【仕事図鑑】でピアピットを紹介していただきました！！</v-card-text>
              </v-card>
            </a>
          </v-col>
        </v-row>

        <!-- ピアノ修理 -->
        <v-row>
          <v-col cols="12" class="px-0 brush1">
            <a id="repair">
              <h2 class="font7 fsize mx-3 white--text">ピアノ修理</h2>
            </a>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6" v-for="list in repairLists" :key="list.title">
            <PfCard>
              {{ list.title }}
              <template #sub>{{ list.sub }}</template>
              <template #body><span v-html="list.body"></span></template>
              <template #image>
                <v-img :src="list.image" height="250px">
                </v-img>
              </template>
            </PfCard>
          </v-col>
        </v-row>
        <!-- フォームと電話 -->
        <InfoP />
        <!-- ピアノクリーニング -->
        <v-row>
          <v-col cols="12" class="px-0 brush2">
            <a id="cleaning">
              <h2 class="font7 fsize mx-3 white--text">ピアノクリーニング</h2>
            </a>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="6" v-for="list in cleaningLists" :key="list.title">
            <PfCard>
              {{ list.title }}
              <template #sub>{{ list.sub }}</template>
              <template #body><span v-html="list.body"></span></template>
              <template #image>
                <v-img :src="list.image" height="250px">
                </v-img>
              </template>
            </PfCard>
          </v-col>
        </v-row>
        <!-- フォームと電話 -->
        <InfoP />
        <!-- ピアノ販売 -->
				<!--
        <v-row>
          <v-col cols="12" class="px-0 brush3">
            <a id="sale">
              <h2 class="font7 fsize mx-3 white--text">ピアノ販売</h2>
            </a>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6" v-for="list in saleLists" :key="list.title">
            <PfCard>
              {{ list.title }}
              <template #sub>{{ list.sub }}</template>
              <template #body>
                <span v-html="list.body"></span>
                <v-img v-if="list.image2" :src="list.image2" class="my-4"></v-img>
                <v-img v-if="list.image3" :src="list.image3"></v-img>
              </template>
              <template #image>
                <v-img v-if="list.image" :src="list.image" height="250px">
                </v-img>
              </template>
              <template #iframe>
                <v-card color="orange lighten-5" outlined>
                  <span v-html="list.iframe">{{ list.iframe }}</span>
                </v-card>
              </template>
            </PfCard>
          </v-col>
        </v-row>
				-->
        <!-- フォームと電話 -->
        <InfoP />
        <!-- ピアノ塗装 -->
        <v-row>
          <v-col cols="12" class="px-0 brush4">
            <a id="paint">
              <h2 class="font7 fsize mx-3 white--text">ピアノ塗装</h2>
            </a>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="6" v-for="list in paintLists" :key="list.title">
            <PfCard>
              {{ list.title }}
              <template #sub>{{ list.sub }}</template>
              <template #body><span v-html="list.body"></span></template>
              <template #image>
                <v-img :src="list.image" height="250px">
                </v-img>
              </template>
            </PfCard>
          </v-col>
        </v-row>
        <!-- フォームと電話 -->
        <InfoP />
        <!-- ピアノ調律 -->
        <v-row>
          <v-col cols="12" class="px-0 brush5">
            <a id="tune">
              <h2 class="font7 fsize mx-3 white--text">ピアノ調律</h2>
            </a>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6" v-for="list in tuneLists" :key="list.title">
            <PfCard>
              {{ list.title }}
              <template #sub>{{ list.sub }}</template>
              <template #body><span v-html="list.body"></span></template>
              <template #image>
                <v-img :src="list.image" height="250px">
                </v-img>
              </template>
            </PfCard>
          </v-col>
        </v-row>
        <!-- ピアノ教室 -->
        <v-row>
          <v-col cols="12" class="px-0 brush6">
            <a id="school">
              <h2 class="font7 fsize mx-3 white--text">ピアノ教室</h2>
            </a>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6" v-for="list in schoolLists" :key="list.title">
            <PfCard>
              {{ list.title }}
              <template #sub>{{ list.sub }}</template>
              <template #body><span v-html="list.body"></span></template>
              <template #image>
                <v-img :src="list.image" height="250px">
                </v-img>
              </template>
            </PfCard>
          </v-col>
        </v-row>
        <!-- フォームと電話 -->
        <InfoP />
        <!-- 消音ユニット取り付け -->
        <v-row>
          <v-col cols="12" class="px-0 brush7">
            <a id="silent">
              <h2 class="font7 fsize mx-3 white--text">消音ユニット取り付け</h2>
            </a>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6" v-for="list in silentLists" :key="list.title">
            <PfCard>
              {{ list.title }}
              <template #sub>{{ list.sub }}</template>
              <template #body><span v-html="list.body"></span></template>
              <template #image>
                <v-img :src="list.image" height="250px">
                </v-img>
              </template>
            </PfCard>
          </v-col>
        </v-row>
        <!-- グランフィール取り付け -->
        <v-row>
          <v-col cols="12" class="px-0 brush8">
            <a id="gran">
              <h2 class="font7 fsize mx-3 white--text">グランフィール取り付け</h2>
            </a>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="6" v-for="list in granLists" :key="list.title">
            <PfCard>
              {{ list.title }}
              <template #sub>{{ list.sub }}</template>
              <template #body><span v-html="list.body"></span></template>
              <template #image>
                <v-img :src="list.image" height="250px">
                </v-img>
              </template>
            </PfCard>
          </v-col>
        </v-row>
        <!-- フォームと電話 -->
        <InfoP />
        <!-- ピアピットについて -->
        <v-row>
          <v-col cols="12" class="px-0 brush9">
            <a id="about">
              <h2 class="font7 fsize mx-3 white--text">ピアピットについて</h2>
            </a>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="6" v-for="list in aboutLists" :key="list.title">
            <PfCard>
              {{ list.title }}
              <template #sub>{{ list.sub }}</template>
              <template #body><span v-html="list.body"></span></template>
              <template #image>
                <v-img :src="list.image" height="250px">
                </v-img>
              </template>
            </PfCard>
          </v-col>
          <v-col cols="12" sm="6" v-for="list in aboutLists" :key="list.title">
            <PfCard>
						ピアピットムービー
              <template #sub>写真をクリックしてください</template>
              <template #image>
								<a href="https://bcove.video/3Xf9olJ">
									<v-img src="@/assets/movie.jpg" height="250px">
									</v-img>
								</a>
              </template>
            </PfCard>
          </v-col>
        </v-row>
      </v-container>

    </template>

    <style>
      .paper {
        background-image: url("@/assets/paper.jpg");
        background-repeat: repeat;
      }
      .brush1 {
        background-image: url("@/assets/brush1.png");
      }
      .brush2 {
        background-image: url("@/assets/brush2.png");
      }
      .brush3 {
        background-image: url("@/assets/brush3.png");
      }
      .brush4 {
        background-image: url("@/assets/brush4.png");
      }
      .brush5 {
        background-image: url("@/assets/brush5.png");
      }
      .brush6 {
        background-image: url("@/assets/brush6.png");
      }
      .brush7 {
        background-image: url("@/assets/brush7.png");
      }
      .brush8 {
        background-image: url("@/assets/brush8.png");
      }
      .brush9 {
        background-image: url("@/assets/brush9.png");
      }
      .fsize {
        font-size:1.75em;
      }
      .f75 {
        font-size:0.75em;
      }
      .fade-enter-active, .fade-leave-active {
        transition: 0.5s;
      }
      .fade-enter, .fade-leave-to {
        opacity: 0;
        /*  transform: scale(0); */
      }
      .u {
        background: linear-gradient(transparent 65%, #ffb74d 65%);
        font-weight: bold;
      }
      .m {
        font-size:1.2em;
        font-weight: bold;
        margin-bottom: 0.3em;
        color: #e65100;
      }
      .bg {
        background: rgba(18,130,75,.5);
      }
</style>
